<template>
  <div>
    <slot name="label">
      <label :for="uid" class="block text-sm font-medium leading-5 text-gray-700 cursor-pointer">
        {{ label }} <span v-if="required" class="text-red-500">*</span>
      </label>
    </slot>
    <div class="mt-1 relative rounded-md shadow-sm">
      <slot>
        <input @input="input" :type="nativeType" :required="required" :id="uid" :value="modelValue"
               class="form-input block w-full sm:text-sm sm:leading-5" :class="cls" :placeholder="placeholder"/>
        <div class="absolute block inset-y-0 right-0 pr-3 flex items-center  cursor-pointer" v-if="type === 'password'">
          <svg v-show="nativeType==='password'" @click="nativeType = 'text'" class="h-5 w-5 text-gray-400" fill="none"
               viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
          </svg>
          <svg v-show="nativeType==='text'" @click="nativeType = 'password'" class="h-5 w-5 text-gray-400" fill="none"
               viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
          </svg>
        </div>

      </slot>
      <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" v-if="isError">
        <svg class="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
             aria-hidden="true">
          <path fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                clip-rule="evenodd"></path>
        </svg>
      </div>
    </div>
    <p class="mt-2 text-sm text-red-600" v-if="isError">
      {{ errorText }}
    </p>
    <slot name="help">
      <p v-if="textHelp" class="mt-2 text-sm text-gray-500">
        {{ textHelp }}
      </p>
    </slot>
  </div>
</template>

<script>
import id from '@/utils/id'

export default {
  name: "UiInputText",
  props: {
    modelValue: {
      default: ''
    },
    type: {
      default: 'text'
    },
    label: {
      default: ''
    },
    id: {
      default: null
    },
    placeholder: {
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    textHelp: {
      default: ''
    },
    errors: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      nativeType: this.type,
      rid: id('id_'),
    }
  },
  computed: {
    isError() {
      return this.errors.length;
    },
    errorText() {
      return this.errors.join(' \n');
    },
    cls() {
      return {
        'input-error pr-10': this.isError,
      }
    },
    uid() {
      return this.id ? this.id : this.rid;
    }

  },
  methods: {
    input(event) {
      this.$emit('update:modelValue', event.target.value)
    }
  },
}
</script>

<style lang="scss">

</style>